<template>
    <footer class="footer level is-paddingless is-marginless" ref="footer">
        <div class="level-item has-text-centered">
            <img style="max-height: 1em"
                    alt="PB_AWS_logo_RGB"
                    title="PB_AWS_logo_RGB"
                    src="https://d1.awsstatic.com/logos/aws-logo-lockups/poweredbyaws/PB_AWS_logo_RGB.61d334f1a1a427ea597afa54be359ca5a5aaad5f.png"
            >
            <img style="max-height: 1em;" alt="AWS GovCloud logo" title="AWS GovCloud logo" :src="GovCloudLogo">
        </div>
        <div class="level-item has-text-centered">
            <router-link :to="{name: 'privacy-policy'}">Privacy Policy</router-link>
        </div>
        <div class="level-item has-text-centered">
            <router-link :to="{name: 'main-site'}">HEAT Site</router-link>
        </div>
        <div class="level-item has-text-centered">
            Created by HEAT ©2019
        </div>
    </footer>
</template>

<script>
    import GovCloudLogo from "../../static/GovCloud_300x169_transparent.png";

    export default {
        name: "HeatFooter",
        computed: {
            GovCloudLogo: ()=> GovCloudLogo,
        }
    }
</script>

<style scoped>

</style>
